"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const EmailStatusBlock = (props) => {
    const { email, verificationStatus } = props.userData;
    const { lastActivityDateString } = props;
    return (react_1.default.createElement("div", { className: "email-status-block" },
        email ? (react_1.default.createElement("p", null,
            "Email: ",
            react_1.default.createElement("b", null, email))) : null,
        verificationStatus ? (react_1.default.createElement("p", null,
            "Status: ",
            react_1.default.createElement("b", null, verificationStatus))) : null,
        lastActivityDateString && (react_1.default.createElement("p", { className: 'last-activity mobile' },
            "Last Activity: ",
            react_1.default.createElement("b", null, lastActivityDateString)))));
};
exports.default = EmailStatusBlock;
